import Step1 from '@elem/SVGIcon/Refurbished/Step1';
import Step2 from '@elem/SVGIcon/Refurbished/Step2';
import Step3 from '@elem/SVGIcon/Refurbished/Step3';
import Step4 from '@elem/SVGIcon/Refurbished/Step4';
import Step5 from '@elem/SVGIcon/Refurbished/Step5';
import Step6 from '@elem/SVGIcon/Refurbished/Step6';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useLang } = useGlobal();
    const { t } = useLang('refurbished');
    const cards: any = [
        {
            icon: <Step1 />,
            step: t('secC_card1_step'),
            text: t('secC_card1_text'),
        },
        {
            icon: <Step2 />,
            step: t('secC_card2_step'),
            text: t('secC_card2_text'),
        },
        {
            icon: <Step3 />,
            step: t('secC_card3_step'),
            text: t('secC_card3_text'),
        },
        {
            icon: <Step4 />,
            step: t('secC_card4_step'),
            text: t('secC_card4_text'),
        },
        {
            icon: <Step5 />,
            step: t('secC_card5_step'),
            text: t('secC_card5_text'),
        },
        {
            icon: <Step6 />,
            step: t('secC_card6_step'),
            text: t('secC_card6_text'),
        },
    ];
    return (
        <div id="refurbished-C" className={`refurbished-C ${css['refurbished-C']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secC_title')}</p>
                </div>
                <ul className="card-box">
                    {cards?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            {card?.icon}
                            <p className="card-step">{card?.step}</p>
                            <p className="card-text">{card?.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
